import PropTypes from 'prop-types';

export default {
  authors: PropTypes.arrayOf(PropTypes.shape({})),
  content: PropTypes.shape({}),
  date: PropTypes.shape({}),
  headline: PropTypes.shape({}),
  id: PropTypes.string,
  primaryImage: PropTypes.shape({}),
  path: PropTypes.string,
};
